import { render, staticRenderFns } from "./ProfileSettingGeneral.vue?vue&type=template&id=ab07be52"
import script from "./ProfileSettingGeneral.vue?vue&type=script&lang=js"
export * from "./ProfileSettingGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports